import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { makeStyles, withStyles } from '@material-ui/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import __ from "lodash";
import { Badge } from '@material-ui/core';

const TabBadge = withStyles(theme => ({
  badge: {
    height: 15,
    minWidth: 15,
    borderRadius: 7
  },
  anchorOriginTopRightRectangle: {
    transform: "scale(1) translate(55%, -80%)"
  },
}))(Badge);

const useTabsStyles = makeStyles(() => ({
  indicator: {
    display: 'none',
  },
}));

const useTabStyles = makeStyles(({ palette, spacing, breakpoints }) => {
  const defaultBgColor = "#eeeeee";
  const defaultSelectedBgColor = '#272C34';
  const defaultMinWidth = {
    md: 100,
  };
  const getTextColor = color => {
    if (Color(color).isLight()) return palette.text.primary;
    return palette.common.white;
  };
  return {
    root: ({ bgColor = defaultBgColor,
             minWidth = defaultMinWidth,
             borderBottomLeftRadius =  undefined,
             borderBottomRightRadius = undefined,
             borderTopLeftRadius = undefined,
             borderTopRightRadius = undefined
           }) => ({
      opacity: 1,
      overflow: 'initial',
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
      borderTopLeftRadius: borderTopLeftRadius === undefined ? spacing(1) : spacing(borderTopLeftRadius),
      borderTopRightRadius: borderTopRightRadius === undefined ? spacing(1) : spacing(borderTopRightRadius),
      borderBottomLeftRadius: spacing(borderBottomLeftRadius),
      borderBottomRightRadius: spacing(borderBottomRightRadius),
      color: getTextColor(bgColor),
      backgroundColor: bgColor,
      transition: '0.2s',
      [breakpoints.up('md')]: {
        minWidth: minWidth.md,
      },
      '&:before': {
        transition: '0.2s',
      },
      '&:not(:first-of-type)': {
        '&:before': {
          content: '" "',
          position: 'absolute',
          left: 0,
          display: 'block',
          height: 20,
          width: 1,
          zIndex: 1,
          marginTop: spacing(0.5),
          backgroundColor: "#eeeeee",
        },
      },
      '& + $selected:before': {
        opacity: 0,
      },
      '&:hover': {
        '&:not($selected)': {
          backgroundColor: Color(bgColor)
            .whiten(0.6)
            .hex(),
        },
        '&::before': {
          opacity: 0,
        },
        '& + $root:before': {
          opacity: 0,
        },
      },
    }),
    selected: ({ selectedBgColor = defaultSelectedBgColor }) => ({
      backgroundColor: selectedBgColor,
      color: getTextColor(selectedBgColor),
      '& + $root': {
      },
      '& + $root:before': {
        opacity: 0,
      },
    }),
    wrapper: {
      marginTop: spacing(0.5),
      textTransform: 'initial',
    },
  };
});

const ChromeTabs = ({ tabs, tabStyle, tabProps, ...props }) => {
  const tabsClasses = useTabsStyles(props);
  const tabClasses = useTabStyles({ ...tabProps, ...tabStyle });
  return (
    <Tabs {...props} classes={tabsClasses}>
      {tabs.map(tab => {
        let label= tab.label;
        if (__.has(tab, 'badge') && tab.badge.content) {
          label = (<TabBadge style={{}} badgeContent={tab.badge.content} color={tab.badge.color||"primary"}>{tab.label}</TabBadge>)
        }
        return (
          <Tab key={tab.label} {...tabProps} {...tab} label={label} classes={tabClasses} />
        )
      })}
    </Tabs>
  );
};

ChromeTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
    }),
  ),
  tabStyle: PropTypes.shape({
    bgColor: PropTypes.string,
    minWidth: PropTypes.shape({}),
  }),
  tabProps: PropTypes.shape({}),
};
ChromeTabs.defaultProps = {
  tabs: [],
  tabStyle: {},
  tabProps: {},
};

export default ChromeTabs;
